<fr-table [config]="tableConfig" [data]="tenants" Id="tenants-table" [paginatorConfig]="paginatorConfig">
</fr-table>
<div above-table-body-space>
  <app-loading-spinner *ngIf="!tenants"></app-loading-spinner>
</div>